export enum EnumTenants {
  Focsie = "23ec642d-e912-4364-a3c4-9b9ef4a436ca",
  FocsieCentre = "f0fbeacb-7e9f-47d0-a412-7677570f4ea5", 
  Socialinter = "4c001c66-df48-4bdb-bb9d-e1151b16a6a8",
  Asia = "6fa4b9be-9411-48e6-879c-53505fae2a8c",
  Sstrn = "9f66153a-1411-482f-9c63-2fc4cb595634",
  Actis = "c341c9a0-e03a-4b11-be87-d8bbfea82399",
  Ressif = "fade294a-b9a9-4bd6-a803-c067d2bd8ef3"
}